<div class="progress-message-container">
  <p>{{progressMessage}}</p>
  <mat-progress-bar [mode]="value ? 'determinate' : 'indeterminate'" [value]="value">
  </mat-progress-bar>
</div>

